import { Dialog, Button, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { TransactionType, TransactionStatus } from 'src/type/transaction';
import Label from 'src/components/label';
import { fDate } from 'src/utils/format-time';
import InfoGrid from 'src/components/ui-kit/info-grid';

import { TopUpWithdrawTxType } from 'src/type/topup-withdraw';
import { fNumber } from 'src/utils/format-number';
import ImageWithPreview from 'src/components/ui-kit/image-with-preview';
import { txStatusLabel } from '../__gold-withdraw/utils';
import { txAction, bankLabel, statusAction } from './utils';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  tx: TopUpWithdrawTxType;
};

export default function TopupWithdrawViewDialog({ open, onClose, tx }: Props) {
  const getInfo = () => {
    if (!tx) return [];

    const { status, createdAt, updatedAt, user, note, type, adminBankAccount, paymentImageUrl } =
      tx;

    return [
      {
        label: 'สถานะ',
        value: (
          <Label
            variant="soft"
            color={
              (status === TransactionStatus.SUCCESS && 'success') ||
              (status === TransactionStatus.PENDING && 'warning') ||
              (status === TransactionStatus.REJECTED && 'error') ||
              (status === TransactionStatus.CANCEL && 'info') ||
              'default'
            }
          >
            {txStatusLabel(status)}
          </Label>
        ),
      },
      { label: 'ผู้ใช้งาน', value: `${user?.firstName} ${user?.lastName}` },
      ...(type === TransactionType.TOPUP_CREDIT
        ? [
            {
              label: 'ยอดที่ต้องการเติม',
              value: `${fNumber(tx.creditAmount || 0)} THB`,
            },
          ]
        : [
            {
              label: 'ยอดที่ต้องการถอน',
              value: `${fNumber(tx.creditAmount || 0)} THB`,
            },
          ]),
      // ...(tx.fee
      //   ? [
      //       {
      //         label: 'ค่าธรรมเนียม',
      //         value: `${fNumber(tx.fee || 0)} THB`,
      //       },
      //     ]
      //   : []),
      // {
      //   label: 'ยอดสุทธิ',
      //   value: `${fNumber(total || 0)} THB`,
      // },
      {
        label: `ชื่อธนาคาร (${bankLabel(type)})`,
        value: `${type === TransactionType.TOPUP_CREDIT ? adminBankAccount?.bank?.name : user?.userWallet?.bank?.name}`,
      },
      {
        label: `ชื่อบัญชี (${bankLabel(type)})`,
        value: `${type === TransactionType.TOPUP_CREDIT ? adminBankAccount?.accountName : user?.userWallet?.accountName}`,
      },
      {
        label: `เลขที่บัญชี (${bankLabel(type)})`,
        value: `${type === TransactionType.TOPUP_CREDIT ? adminBankAccount?.accountNumber : user?.userWallet?.accountNumber}`,
      },
      { label: 'วันที่ทำรายการ', value: fDate(createdAt, 'DD MMMM BBBB HH:mm น.') },
      ...([TransactionStatus.SUCCESS, TransactionStatus.REJECTED].includes(status)
        ? [
            {
              label: `วันที่${statusAction(status)}`,
              value: fDate(updatedAt, 'DD MMMM BBBB HH:mm น.'),
            },
          ]
        : []),
      ...(paymentImageUrl
        ? [
            {
              label: 'หลักฐานการโอนเงิน',
              value: <ImageWithPreview src={paymentImageUrl} alt="" />,
            },
          ]
        : []),
      {
        label: 'หมายเหตุ',
        value: note || '-',
      },
    ];
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle sx={{ pb: 2, display: 'flex' }}>รายการ{txAction(tx.type)}</DialogTitle>

      <DialogContent>
        <InfoGrid infos={getInfo()} />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
